/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import { TableCell, TableRow, Checkbox, Typography, TextField } from "@mui/material";
import clsx from "clsx";
import { Link, NavLink } from "react-router-dom";
import ElipsisIcon from "../../../../../assets/images/icon_actions/Elipsis.svg";
import { Image, Space, Dropdown, Menu, Modal } from "antd";
import { purchaseInvoiceHistory } from "../../../../../config/constant";
import ViewIcon from "../../../../../assets/images/icon_actions/View.svg";
import moment from 'moment';
import { currencyFormat, checkCRUDPermission, checkComponentPermission, getColumnWidth, downloadTitle, idNamingConversion } from "../../../../../helpers/utilities";
import crudActions from "../../../../CRUD/redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { toast } from 'react-toastify';
import usePrevious from "../../../../Shared/components/Previous";
import PurchaseInvoiceModal from "../../../../Shared/components/PurchaseInvoiceModal";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import { AESEncrypt } from "../../../../../helpers/Crypto";
import SearchText from '../../../../Shared/components/SearchText';


export const ListTable = (props) => {
    const { onSelected, onRequestSort, sortOrder, sortBy, details, businessDetails, productGstdetails, loadTasks, loadMore, loadMoreContent, loadMoreTask, roleManagement, search, dateValue, dataSettle, overDue, supplierId } = props;
    const [open, setOpen] = useState(false);
    const { rejectDetails } = useSelector(state => state.younoteAdminSetupReducer);
    const [selected, setSelected] = useState([]);
    const { createDetails, createError, readDetails, readError, createLoader, editLoader, editDetails } = useSelector(state => state.crudReducer);
    const dispatch = useDispatch();
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const prevEditDetails = usePrevious(editDetails);
    const prevReadDetails = usePrevious(readDetails);
    const prevReadError = usePrevious(readError);
    const [deleteModal, setDeleteModal] = useState(false);
    const [invoiceId, setInvoiceId] = useState('');
    // const [number, setNumber] = useState('');
    const [comments, setComments] = useState('');
    const [datas, setDatas] = useState({});
    const [visible, setVisible] = useState(false);
    const [reasonId, setReasonId] = useState('');
    const [originalDetails, setOrigialDetails] = useState('');
    const [copy, setCopy] = useState(false)

    useEffect(() => {
        onSelected(selected);
    }, [selected]);

    const handleClick = (e, id) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected);
    };

    const isSelected = (name) => selected.indexOf(name) !== -1;

    const handleDeleteModal = (value) => {
        setDeleteModal(value); setReasonId('');
    }

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            toast.dismiss();
            toast(createDetails);
            loadTasks();
            handleDeleteModal();
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let message = createError.error.message;
            handleDeleteModal();
            toast.dismiss();
            toast.error(message);
        }
    }, [createDetails, createError]);


    const handleShareDocument = (data, copy) => {
        setCopy(copy);
        if (data?.source !== 'PURCHASE ORDER') {
            dispatch({ type: crudActions.READ_DETAILS_START, id: data.selfBillId, url: "purchaseSelfBill" });
        } else {
            data.selfBillItems = data?.purchaseInvoiceItems || [];
            data.includeGst = data?.purchaseOrder?.includeGst || false;
            setOrigialDetails(data);
            setOpen(true);
        }
    }

    useEffect(() => {
        if (prevReadDetails !== undefined && readDetails && prevReadDetails !== readDetails) {
            setOpen(true);
            setOrigialDetails(readDetails);
        } else if (prevReadError !== undefined && readError && prevReadError !== readError) {

        }
    }, [readDetails]);

    const handleClose = (o) => (
        setOpen(o)
    );

    const onDelete = (data) => {
        setDeleteModal(true);
        setInvoiceId(data.id);
        //setNumber(data.serialNo);
    }

    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            toast.dismiss();
            toast(editDetails);
            loadTasks();
            handleOk();
        }
    }, [editDetails]);

    const handleOk = () => {
        setVisible(false);
        setDatas({});
        setComments('');
    };

    const onHold = (data) => {
        setDatas(data);
        setVisible(true);
    }

    const handleHoldSubmit = () => {
        dispatch({
            type: crudActions.EDIT_DETAILS_START,
            url: "purchaseInvoice",
            title: `Purchase Invoice ${datas.onHold ? 'Un Hold' : 'Hold'}`,
            id: datas.id,
            details: { 'onHold': !datas.onHold, comment: comments }
        });
    }

    const onDeleteOk = () => {
        dispatch({
            type: crudActions.CREATE_DETAILS_START,
            url: `purchaseInvoice/${invoiceId}/cancel/${reasonId}`,
            typeTitle: "Invoice has been Cancelled Successfully",
            id: datas.id
        })
    }

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const classes = customStyles();

    return (
        <>
            <CustomInfiniteScroll
                loadMore={loadMore}
                loadMoreContent={loadMoreContent}
                heads={purchaseInvoiceHistory}
                onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
                sortOrder={sortOrder}
                width={true}
                sortBy={sortBy}
                details={details}
                className={classes.margin15t}
                selected={selected}
                onSelected={(value) => setSelected(value)}
                loadMoreTask={() => loadMoreTask()}
                component={
                    <>
                        {
                            !loadMore || details === '' ? (
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell className={classes.textAlignCenter} colSpan={purchaseInvoiceHistory.length}><div className={classes.loadMoreCircle}></div></TableCell>
                                </TableRow>
                            ) : (
                                <React.Fragment>
                                    {
                                        details && details.length > 0 ? details.map((data, i) => (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} key={i}  >
                                                <TableCell className={clsx('checkbox', classes.tablealign)} onClick={(e) => handleClick(e, data.id)} padding="checkbox">
                                                    <Checkbox color="primary" checked={isSelected(data.id)} />
                                                </TableCell>
                                                <TableCell style={{ width: getColumnWidth(purchaseInvoiceHistory, 0) }} className={classes.positionRelative}>
                                                    {
                                                        roleManagement !== '' && checkCRUDPermission('Supplier Invoice History', 'view', 'Purchase') ?
                                                            <><Link id={idNamingConversion('View_' + data.id, 'supplierInvoiceHistory', 'Link')} style={{ width: getColumnWidth(purchaseInvoiceHistory, 0) }} to={`/purchase/transactions/invoice-history/${AESEncrypt(data.id)}/view`} className={clsx(classes.color, classes.positionRelative, classes.disBlock, classes.bold)}>
                                                                {data?.serialNo || '---'}
                                                            </Link>{data.onHold && <b className={clsx(classes.new, classes.openButton, classes.statusButton)}>Hold</b>}</> : <><span style={{ width: getColumnWidth(purchaseInvoiceHistory, 0) }}>{data?.serialNo}</span>{data.onHold && <b className={clsx(classes.new, classes.openButton, classes.statusButton)}>Hold</b>}</>
                                                    }
                                                </TableCell>
                                                <TableCell style={{ width: getColumnWidth(purchaseInvoiceHistory, 1) }}><span style={{ width: getColumnWidth(purchaseInvoiceHistory, 1) }}>{data?.supplierRefNum || '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(purchaseInvoiceHistory, 2) }}><span style={{ width: getColumnWidth(purchaseInvoiceHistory, 2) }}>{moment(data.invoiceDate).format('DD MMM YYYY')}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(purchaseInvoiceHistory, 3) }}><span style={{ width: getColumnWidth(purchaseInvoiceHistory, 3) }}>{moment(data.dueDate).format('DD MMM YYYY')}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(purchaseInvoiceHistory, 4) }}><span style={{ width: getColumnWidth(purchaseInvoiceHistory, 4) }}>{moment(data.createTs).format('DD MMM YYYY hh:mm A')}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(purchaseInvoiceHistory, 5) }}><span style={{ width: getColumnWidth(purchaseInvoiceHistory, 5) }}>{data?.supplier?.name || '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(purchaseInvoiceHistory, 6) }}><span style={{ width: getColumnWidth(purchaseInvoiceHistory, 6) }}>{data?.supplier?.serialNo || '----'}</span></TableCell>
                                                {/* <TableCell>{`SB${data.selfBillId}`}</TableCell> */}
                                                <TableCell style={{ width: getColumnWidth(purchaseInvoiceHistory, 7) }} className={classes.rightAlignAmount}><span style={{ width: getColumnWidth(purchaseInvoiceHistory, 7) }}>{`₹ ${currencyFormat(data.invoiceAmount)}`}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(purchaseInvoiceHistory, 8) }} className={classes.rightAlignAmount}><span style={{ width: getColumnWidth(purchaseInvoiceHistory, 8) }}>{`₹ ${currencyFormat(data.balanceAmount)}`}</span></TableCell>
                                                <TableCell>
                                                    <Space direction="horizontal" align="center" size={[0, 0]} className={classes.iconPadding}>
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Supplier Invoice History', 'view', 'Purchase') &&
                                                            <Link id={idNamingConversion('View_' + data.id, 'supplierInvoiceHistory', 'Icon')} to={`/purchase/transactions/invoice-history/${AESEncrypt(data.id)}/view`}>
                                                                <Image
                                                                    src={ViewIcon}
                                                                    preview={false}
                                                                />
                                                            </Link>
                                                        }
                                                        <Dropdown
                                                            trigger={['click']}
                                                            placement={'bottomRight'}
                                                            overlay={
                                                                <Menu className={clsx(classes.groupMenu)}>
                                                                    <Menu.Item key={"arrow"} className={clsx(classes.accordionSubmenuArrow)}></Menu.Item>
                                                                    {
                                                                        !data?.onHold ?
                                                                            <>
                                                                                {
                                                                                    roleManagement !== '' && checkComponentPermission('Supplier Invoice History', 'Ellipsis Action', 'Make Payment') &&
                                                                                    data.source === 'PURCHASE SELF BILL' &&
                                                                                    <Menu.Item key={"settle"}>
                                                                                        <NavLink className={clsx({ [classes.disabled]: data.isSettled })}
                                                                                            id={idNamingConversion('Make Payment_' + data.id, 'supplierInvoiceHistory', 'Icon')}
                                                                                            to={`/purchase/purchase-management/supplier-payment/${AESEncrypt(data.supplierId)}/${data.id}/create`}>Make Payment
                                                                                        </NavLink>
                                                                                    </Menu.Item>
                                                                                }
                                                                                {
                                                                                    data.billStatus === 'CREATED' && (
                                                                                        <Menu.Item key={"cancel"} title={data.source === 'PURCHASE DEBIT NOTE' ? 'Debit Note cant be cancelled' : ''}>
                                                                                            {
                                                                                                roleManagement !== '' && checkComponentPermission('Supplier Invoice History', 'Ellipsis Action', 'Cancel Invoice') && data.source === 'PURCHASE SELF BILL' &&
                                                                                                <NavLink to={'#'} className={clsx({ [classes.disabled]: data.settledAmount > 0 })} onClick={() => onDelete(data)} id={idNamingConversion('Cancel Invoice_' + data.id, 'supplierInvoiceHistory', 'Icon')}>Cancel Invoice</NavLink>
                                                                                            }
                                                                                        </Menu.Item>
                                                                                    )
                                                                                }
                                                                                {
                                                                                    roleManagement !== '' && checkComponentPermission('Supplier Invoice History', 'Ellipsis Action', 'Hold') &&
                                                                                    <Menu.Item key={"hold"}><NavLink className={clsx({ [classes.disabled]: data.isSettled })} to={'#'} onClick={() => onHold(data)} id={idNamingConversion('Hold_' + data.id, 'supplierInvoiceHistory', 'Icon')}>Hold</NavLink></Menu.Item>
                                                                                }
                                                                            </> : <>
                                                                                {
                                                                                    roleManagement !== '' && checkComponentPermission('Supplier Invoice History', 'Ellipsis Action', 'Hold') &&
                                                                                    <Menu.Item key={"hold"}><NavLink to={'#'} onClick={() => onHold(data)} id={idNamingConversion('Un Hold_' + data.id, 'supplierInvoiceHistory', 'Icon')}>Un Hold</NavLink></Menu.Item>
                                                                                }
                                                                            </>
                                                                    }
                                                                    {
                                                                        roleManagement !== '' && checkComponentPermission('Supplier Invoice History', 'Ellipsis Action', 'Share Document') &&
                                                                        <Menu.Item key={"View Document"}><NavLink to={'#'} onClick={() => handleShareDocument(data, false)} id={idNamingConversion('View Original_' + data.id, 'supplierInvoiceHistory', 'Icon')}>View Original</NavLink></Menu.Item>
                                                                    }
                                                                    {
                                                                        roleManagement !== '' && checkComponentPermission('Supplier Invoice History', 'Ellipsis Action', 'View Copy') &&
                                                                        <Menu.Item key={"View Copy"}><NavLink id={idNamingConversion('View Copy_' + data.id, 'supplierInvoiceHistory', 'Icon')} to={'#'}
                                                                            onClick={() => handleShareDocument(data, true)} >View Copy</NavLink></Menu.Item>
                                                                    }

                                                                </Menu>
                                                            }>
                                                            <Image
                                                                id={idNamingConversion('Elipsis_' + data.id, 'supplierInvoiceHistory', 'Icon')}
                                                                src={ElipsisIcon}
                                                                preview={false}
                                                            />
                                                        </Dropdown>
                                                    </Space>
                                                </TableCell>
                                            </TableRow>
                                        )) : (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell className={classes.textAlignCenter} colSpan={purchaseInvoiceHistory.length}>
                                                    {
                                                        search !== '' ? <SearchText /> :
                                                            <div className={clsx(classes.noResultsText, classes.textAlignCenter)}>
                                                                {
                                                                    (supplierId || (dateValue[0] !== null && dateValue[1] !== null) || overDue || dataSettle) ? <>{
                                                                        dataSettle === 'un-paid' ? <><p>All Invoices will be listed here when transactions are recorded by the system</p></> : 'Sorry, we couldn’t find any match for the filtered criteria. Please refine your filter.'
                                                                    }</> : <>
                                                                        {
                                                                            dataSettle === '' ? 'Sorry, we couldn’t find any match for the filtered criteria. Please refine your filter.' : 'All Invoices will be listed here when transactions are recorded by the system'
                                                                        }
                                                                    </>
                                                                }
                                                            </div>
                                                    }
                                                </TableCell>
                                            </TableRow>
                                        )
                                    }
                                </React.Fragment>
                            )
                        }
                    </>
                }
            />
            {
                open && (
                    <PurchaseInvoiceModal
                        open={open} copy={copy}
                        title={downloadTitle(readDetails, 'supply-bill')}
                        //title={`Purchase-Bill-${readDetails?.id}`}
                        handleClose={(o) => handleClose(o)}
                        format={originalDetails?.billFormat}
                        link={""} {...props} businessDetails={businessDetails}
                        details={originalDetails} productGst={productGstdetails} />

                )
            }
            <Modal
                title={'Info Log Message'}
                width={460}
                open={visible}
                onOk={() => handleOk()}
                onCancel={() => handleOk()}
                // closeIcon={<CloseIcon />}
                footer={[
                    <NavLink to={"#"}
                        className={clsx(classes.modalBtn, { [classes.loadingA]: editLoader }, { [classes.disabled]: comments === '' })}
                        onClick={() => handleHoldSubmit()}
                    >OK</NavLink>
                ]}
                className={clsx(classes.commonPopup, classes.commonPopupText, classes.removeUnderline, classes.deletePopup)}>
                <Typography variant={'subtitle1'} className={clsx(classes.fonSize14, classes.textAlignLeft)} style={{ color: "#1c314c" }}>
                    Please mention your reason for hold / unhold comments below</Typography>
                <Space direction={'vertical'} className={classes.modalPaper} style={{ width: "100%", margin: "0" }}>
                    <TextField autoComplete='one-time-code'
                        label={["Comments ", <span key={"Comments"} className={classes.colorRedRequired}> *</span>]}
                        variant={'standard'}
                        fullWidth
                        value={comments}
                        InputProps={{
                            classes: {
                                input: classes.textFieldColor,
                            }
                        }}
                        InputLabelProps={{
                            className: classes.textFieldLableColorCustom,
                        }}
                        onChange={(e) => setComments(e.target.value)}
                    />
                </Space>
            </Modal>
            <Modal
                title={'Info Log Message'}
                width={460}
                open={deleteModal}
                onOk={() => handleDeleteModal(!deleteModal)}
                onCancel={() => handleDeleteModal(!deleteModal)}
                // closeIcon={<CloseIcon />}
                footer={
                    [
                        <NavLink to={"#"}
                            className={clsx(classes.modalBtn, { [classes.loadingA]: createLoader }, { [classes.disabled]: reasonId === '' })}
                            onClick={() => onDeleteOk()}
                        >OK</NavLink>
                    ]}
                className={clsx(classes.commonPopup, classes.commonPopupText, classes.removeUnderline, classes.deletePopup)}>
                <Typography variant={'subtitle1'} className={clsx(classes.fonSize14, classes.textAlignLeft)} style={{ color: "#1c314c" }}>
                    Are You Sure you want to Cancel the Selected Invoice? If Yes Mention the Reason for Cancellation below</Typography>
                <AutoCompleteComponent
                    name={["Reason Codes ", <span key={'Catalogue Name'} className={classes.colorRedRequired}> *</span>]}
                    heads={[{ 'key': 'rejectReasonDesc', 'name': 'Description' }, { 'key': 'rejectReasonCode', 'name': 'Codes' }]}
                    details={rejectDetails}
                    parentValue={customObject(rejectDetails, reasonId)}
                    position={"bottom"}
                    customClasses={classes.margin20t}
                    onChange={(data) => setReasonId(data.id)}
                />
            </Modal>
        </>
    )
}